<template>
    <div class="main-box mh-a">
        <iristar-dividing> {{ $t("title.title3") }} </iristar-dividing>
        <div class="iristar-pro-item">
            <div class="flex a-i-c" v-if="productDetial">
                <el-image
                    class="border-r m-details"
                    :src="productDetial.img"
                    fit="cover"
                ></el-image>
                <div class="p20 flex1">
                    <h4 class="fs24">{{ productDetial.type }}</h4>
                    <h4 class="lh30 fs18 c-g-d">
                        {{ productDetial.name }}
                    </h4>
                    <div>
                        <el-tag
                            class="m10"
                            size="small"
                            type="info"
                            v-for="(tag, idx) in productDetial.point"
                            :key="`${idx}_tag`"
                            >{{ tag }}</el-tag
                        >
                    </div>
                    <p class="fs14 text-indent lh30 c-g-d">
                        {{ productDetial.desc }}
                    </p>
                    <el-table :data="productDetial.param" class="w-total">
                        <el-table-column prop="key"> </el-table-column>
                        <el-table-column prop="val"> </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IristarDividing from "@/components/IristarDividing";
import ModuleList from "@/assets/module/module";
import ModuleListEn from "@/assets/module/module-en";
export default {
    name: "ModuleDetial",
    computed: {
        productDetial() {
            let list =
                this.$store.state.language === "zh" ? ModuleList : ModuleListEn;
            let detialArr = list.filter((item) => {
                return item.type == this.$route.params.index;
            });
            return detialArr[0];
        },
    },
    components: {
        IristarDividing,
    },
};
</script>

<style lang="less">
</style>